import React, { useState } from "react";
import "./i18n";
import Body from "./Body";
import Navbar from "./Components/Navbar/Navbar";
import TouristTaxBanner from "./TouristTaxBanner";
import About from "./About";
import Features from "./Features";
import HomeFleetCarousel from "./HomeFleetCarousel";
import LatestBlogPost from "./LatestBlogPost";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const App = () => {
  const [choosedCar, setChoosedCar] = useState({
    brand: null,
    code: null,
    picture: null,
    pictureSource: null,
  });
  const [reservationModalOpen, setReservationModalOpen] = useState(false);

  const onReserveClick = (car) => {
    setChoosedCar(car);
    setReservationModalOpen(true);
  };

  return (
    <>

      <Navbar />

      <Dialog
        open={reservationModalOpen}
        onClose={() => setReservationModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <IconButton
          onClick={() => setReservationModalOpen(false)}
          sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>
        <Body
          choosedCar={choosedCar}
          setChoosedCar={setChoosedCar}
          isModal
        />
      </Dialog>

      {/* Hero — reservation form */}
      <TouristTaxBanner />
      <Body choosedCar={choosedCar} setChoosedCar={setChoosedCar} />

      {/* About banner */}
      <About />

      {/* How We Work */}
      <Features />

      {/* Fleet carousel */}
      <HomeFleetCarousel onReserveClick={onReserveClick} />

      {/* Latest blog article */}
      <LatestBlogPost />
    </>
  );
};

export default App;
